import * as React from 'react';
import { createContext, Reducer, useContext, useReducer } from 'react';
import { associatedLendersApplicationInitialState, IAssociatedLendersApplicationState } from './interface';
import { AssociatedLendersDispatch, IAssociatedLendersAction } from './AssociatedLendersAction';
import { AssociatedLendersReducer } from './AssociatedLendersReducer';
import type { FCWithChildren } from '../../types/FCWithChildren';

const AssociatedLendersContext = createContext<IAssociatedLendersApplicationState | undefined>(undefined);

export const AssociatedLendersDispatchContext = createContext<AssociatedLendersDispatch | undefined>(undefined);

export const AssociatedLendersProvider: FCWithChildren = ({ children }) => {
  const [context, dispatch] = useReducer<Reducer<IAssociatedLendersApplicationState, IAssociatedLendersAction>>(
    AssociatedLendersReducer,
    associatedLendersApplicationInitialState
  );

  return (
    <AssociatedLendersContext.Provider value={context}>
      <AssociatedLendersDispatchContext.Provider value={dispatch}>{children}</AssociatedLendersDispatchContext.Provider>
    </AssociatedLendersContext.Provider>
  );
};

export const useAssociatedLendersContext = (): [IAssociatedLendersApplicationState, AssociatedLendersDispatch] => {
  const context = useContext(AssociatedLendersContext);
  const dispatch = useContext(AssociatedLendersDispatchContext);
  if (context === undefined || dispatch === undefined) {
    throw new Error('useAssociatedLendersContext must be used within a AssociatedLendersProvider');
  }
  return [context, dispatch];
};
